import {
  Enums,
  getEnabledElement,
  getOrCreateCanvas,
  StackViewport
} from '@cornerstonejs/core';
import { ToolGroupManager } from '@cornerstonejs/tools';
import html2canvas from 'html2canvas';
import { ImagemService } from './../../../../extensions/default/src/Service/ImagemService';

export const UpdateViewportPreview = (
  downloadViewportElement,
  internalCanvas,
  fileType,
  DEFAULT_SIZE
) =>
  new Promise(resolve => {
    const enabledElement = getEnabledElement(downloadViewportElement);

    const { viewport: downloadViewport, renderingEngine } = enabledElement;

    // Note: Since any trigger of dimensions will update the viewport,
    // we need to resize the offScreenCanvas to accommodate for the new
    // dimensions, this is due to the reason that we are using the GPU offScreenCanvas
    // to render the viewport for the downloadViewport.
    renderingEngine.resize();

    // Trigger the render on the viewport to update the on screen
    downloadViewport.render();

    downloadViewportElement.addEventListener(
      Enums.Events.IMAGE_RENDERED,
      function updateViewport(event) {
        const enabledElement = getEnabledElement(event.target);
        const { viewport } = enabledElement;
        const { element } = viewport;
        const downloadCanvas = getOrCreateCanvas(element);
        const type = 'image/' + fileType;
        const dataUrl = downloadCanvas.toDataURL(type, 1);
        let newWidth = element.offsetHeight;
        let newHeight = element.offsetWidth;
        if (newWidth > DEFAULT_SIZE || newHeight > DEFAULT_SIZE) {
          const multiplier = DEFAULT_SIZE / Math.max(newWidth, newHeight);
          newHeight *= multiplier;
          newWidth *= multiplier;
        }
        resolve({ dataUrl, width: newWidth, height: newHeight });
        downloadViewportElement.removeEventListener(
          Enums.Events.IMAGE_RENDERED,
          updateViewport
        );
      }
    );
  });

export const LoadImage = (activeViewportElement, viewportElement, width, height, cornerstoneViewportService, VIEWPORT_ID, MAX_TEXTURE_SIZE) =>
  new Promise(resolve => {
    if (activeViewportElement && viewportElement) {
      const activeViewportEnabledElement = getEnabledElement(
        activeViewportElement
      );

      if (!activeViewportEnabledElement) {
        return;
      }

      const { viewport } = activeViewportEnabledElement;

      const renderingEngine = cornerstoneViewportService.getRenderingEngine();
      const downloadViewport = renderingEngine.getViewport(VIEWPORT_ID);

      if (downloadViewport instanceof StackViewport) {
        const imageId = viewport.getCurrentImageId();
        const properties = viewport.getProperties();

        downloadViewport.setStack([imageId]).then(() => {
          downloadViewport.setProperties(properties);

          const newWidth = Math.min(width || image.width, MAX_TEXTURE_SIZE);
          const newHeight = Math.min(
            height || image.height,
            MAX_TEXTURE_SIZE
          );

          resolve({ width: newWidth, height: newHeight });
        });
      } else if (downloadViewport instanceof VolumeViewport) {
        const actors = viewport.getActors();
        // downloadViewport.setActors(actors);
        actors.forEach(actor => {
          downloadViewport.addActor(actor);
        });

        downloadViewport.setCamera(viewport.getCamera());
        downloadViewport.render();

        const newWidth = Math.min(width || image.width, MAX_TEXTURE_SIZE);
        const newHeight = Math.min(height || image.height, MAX_TEXTURE_SIZE);

        resolve({ width: newWidth, height: newHeight });
      }
    }
  });

export const ToggleAnnotations = (
  toggle,
  viewportElement,
  activeViewportElement
) => {
  const activeViewportEnabledElement = getEnabledElement(
    activeViewportElement
  );

  const downloadViewportElement = getEnabledElement(viewportElement);

  const {
    viewportId: activeViewportId,
    renderingEngineId,
  } = activeViewportEnabledElement;
  const { viewportId: downloadViewportId } = downloadViewportElement;

  if (!activeViewportEnabledElement || !downloadViewportElement) {
    return;
  }

  const toolGroup = ToolGroupManager.getToolGroupForViewport(
    activeViewportId,
    renderingEngineId
  );

  // add the viewport to the toolGroup
  toolGroup.addViewport(downloadViewportId);

  Object.keys(toolGroup._toolInstances).forEach(toolName => {
    // make all tools Enabled so that they can not be interacted with
    // in the download viewport
    if (toggle && toolName !== 'Localizador') {
      try {
        toolGroup.setToolEnabled(toolName);
      } catch (e) {
        console.log(e);
      }
    } else {
      toolGroup.setToolDisabled(toolName);
    }
  });
};

export const DownloadBlob = (filename, fileType, VIEWPORT_ID) => {
  const file = `${filename}.${fileType}`;
  const divForDownloadViewport = document.querySelector(
    `div[data-viewport-uid="${VIEWPORT_ID}"]`
  );
  html2canvas(divForDownloadViewport).then(canvas => {
    const link = document.createElement('a');
    link.download = file;
    link.href = canvas.toDataURL(fileType, 1.0);
    link.click();
  });
};

export const DownloadBlobSec = (filename, fileType, VIEWPORT_ID) => {
  const file = `${filename}.${fileType}`;
  const divForDownloadViewport = VIEWPORT_ID;
  // const divForDownloadViewport = document.querySelector(
  //   `div[data-viewport-uid="${VIEWPORT_ID}"]`
  // );
  html2canvas(divForDownloadViewport).then(canvas => {
    const link = document.createElement('a');
    link.download = file;
    link.href = canvas.toDataURL(fileType, 1.0);

    const enabledElement = cornerstone.getEnabledElements()[0];
    const instanceUid = enabledElement.viewport.csImage.imageId
      .split('instances/')[1]
      .split('/frames')[0];

    const imagemSecundariaDTO = { InstanceUid: instanceUid, Image: link.href };

    const imagemService = new ImagemService();
    imagemService.postImagemSecundaria(imagemSecundariaDTO)
      .then(resp => {
        if (resp.status === 200)
          window.location.reload();
      })
      .catch(error => {
        console.log(error);
        setMsgFalha('Falha ao gerar imagem secundária.');
      })

  });
};
